var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RankingRow = void 0;

var _react = _interopRequireDefault(require("react"));

var _get = _interopRequireDefault(require("lodash/get"));

var _Basic = require("../../../elements/Basic");

var _Logos = require("../Basic/Logos");

var _PlayerName = _interopRequireDefault(require("../Basic/PlayerName"));

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Ranking/RankingRow.js";

var getMainValue = function getMainValue(_ref) {
  var rankingType = _ref.rankingType,
      rankingItem = _ref.rankingItem;

  switch (rankingType) {
    case 'GOALS':
      return rankingItem.goalValue;

    case 'SCORER':
      return rankingItem.goalValue + rankingItem.assistValue;

    case 'ASSISTS':
      return rankingItem.assistValue;

    case 'YELLOW_CARDS':
    case 'RED_CARDS':
      return rankingItem.cardValue;

    default:
      return 0;
  }
};

var RankingRow = function RankingRow(_ref2) {
  var rankingType = _ref2.rankingType,
      item = _ref2.item;
  return [_react.default.createElement(_Basic.Text, {
    key: "position",
    tableWidth: 9 / 100,
    maxWidth: 45,
    columnStyling: {
      center: true
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 5
    }
  }, item.position), _react.default.createElement(_Basic.View, {
    key: "logo",
    tableWidth: 8 / 100,
    maxWidth: 50,
    columnStyling: {
      center: true,
      my: 0,
      mx: 0
    },
    height: "100%",
    isFlex: true,
    center: true,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 5
    }
  }, _react.default.createElement(_Logos.TeamLogo, {
    size: 20,
    my: 0,
    mx: 0,
    src: (0, _get.default)(item, 'player.team.imageUrl'),
    teamID: (0, _get.default)(item, 'player.team.imageUrl'),
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 9
    }
  })), _react.default.createElement(_Basic.Column, {
    key: "playerName",
    columnStyling: {
      flexing: true,
      justifyContent: 'center',
      alignItems: 'flex-start',
      minWidth: 0
    },
    isFlex: true,
    width: "100%",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 55,
      columnNumber: 5
    }
  }, _react.default.createElement(_PlayerName.default, {
    isTitle: false,
    pl: 10,
    numberOfLines: 1,
    textWrap: true,
    bold: true,
    player: item.player,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 66,
      columnNumber: 9
    }
  })), _react.default.createElement(_Basic.Text, {
    key: "goals",
    tableWidth: 10 / 100,
    maxWidth: 55,
    columnStyling: {
      center: true
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 68,
      columnNumber: 5
    }
  }, rankingType === 'SCORER' && item.goalValue), _react.default.createElement(_Basic.Text, {
    key: "assists",
    tableWidth: 10 / 100,
    maxWidth: 55,
    columnStyling: {
      center: true
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 71,
      columnNumber: 5
    }
  }, rankingType === 'SCORER' && item.assistValue), _react.default.createElement(_Basic.Text, {
    key: "rank",
    tableWidth: 10 / 100,
    maxWidth: 55,
    bold: true,
    columnStyling: {
      center: true
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 74,
      columnNumber: 5
    }
  }, getMainValue({
    rankingType: rankingType,
    rankingItem: item
  }))];
};

exports.RankingRow = RankingRow;
var _default = RankingRow;
exports.default = _default;